export const SENTRY_APPLICATION = 'loan-commerces';

export const SENTRY_ENABLED_ENVIRONMENTS = ['qa', 'staging', 'production'];

export function getSentryDsn() {
  return (process.env.REACT_APP_SENTRY_DSN || '').trim();
}

export function getSentryEnvironment() {
  const explicit = (process.env.REACT_APP_SENTRY_ENVIRONMENT || '').trim();
  if (explicit) {
    return explicit;
  }

  return (process.env.REACT_APP_ENVIRONMENT || '').trim();
}

export function getSentryRelease() {
  const release = (process.env.REACT_APP_SENTRY_RELEASE || '').trim();
  if (release) {
    return release;
  }

  return (process.env.REACT_APP_VERSION || '').trim();
}

export function isSentryRuntimeEnabled() {
  const dsn = getSentryDsn();
  const environment = getSentryEnvironment();

  return Boolean(dsn) && SENTRY_ENABLED_ENVIRONMENTS.includes(environment);
}
